import { render } from "./ResetPassword.vue?vue&type=template&id=1a0e9cd0&scoped=true&ts=true"
import script from "./ResetPassword.ts?vue&type=script&lang=ts"
export * from "./ResetPassword.ts?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=1a0e9cd0&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0e9cd0"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput,QIcon,QBtn});
